export default __webpack_public_path__ + "static/media/attractions1.e3953fe6.png";